<template>
  <div class="media-viewer">
    <div class="image" v-if="type === MEDIA_TYPES.PHOTO">
      <div class="image-container">
        <img :src="src.url">
        <div class="extra-info" v-if="src.date">{{ getDateFormatted(src.date) }}</div>
      </div>
      <LocationMap v-if="src.location" :location="getMarker({...src.location, label: src.label})" :locations="getLocationMarkers(src.locations)" />
    </div>

    <div class="audio" v-if="type === MEDIA_TYPES.AUDIO">
      <div class="audio-container">
        <audio controls autoplay>
          <source v-bind:src="src.url" type="audio/mpeg">
          Your browser does not support the audio element.
        </audio>
        <div class="extra-info" v-if="src.date">{{ getDateFormatted(src.date) }}</div>
      </div>
      <LocationMap v-if="src.location" :location="getMarker(src)" />
    </div>

    <div class="map" v-if="type === MEDIA_TYPES.LOCATION">
      <div class="location-info">Latitud: {{ src.location.latitude }} | Longitud: {{ src.location.longitude }} | Altitud: {{ src.location.altitude }}</div>
      <LocationMap
        v-if="src"
        :location="getMarker(src.location)"
        :refLocation="getMarker(src.refLocation)"
        :locations="getLocationMarkers(src.locations)"
      />
    </div>

    <div class="pdf" v-if="type === MEDIA_TYPES.PDF">
      <iframe v-bind:src="src.url" width="100%" height="100%" frameBorder="0"/>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import LocationMap from '@/components/maps/LocationMap.vue'
import { MarkerPosition } from '@/types//Maps'
import { TemplateQuestionsTypes } from '@/types/Fillgrid'
import moment from 'moment'

@Component({
  components: {
    LocationMap
  }
})
export default class Fillgrid extends Vue {
  @Prop()
  type: string

  @Prop()
  src: any

  MEDIA_TYPES = TemplateQuestionsTypes

  getMarker (location: any) {
    // If question was type photo, location must be extracted
    if (location && (location.location || (location.latitude && location.longitude))) {
      const latitude = location.location ? location.location.latitude : location.latitude
      const longitude = location.location ? location.location.longitude : location.longitude
      const label = location.label
      return new MarkerPosition(latitude, longitude, undefined, label)
    }
    return undefined
  }

  getDateFormatted (date: string) {
    return moment.utc(date).local().format('dddd D [de] MMMM [de] YYYY, [a las] HH:mm [hrs.]')
  }

  getLocationMarkers (locations: any) {
    return locations && locations
      .map((loc: any) => this.getMarker(loc))
      .filter(Boolean)
  }
}
</script>

<style lang="scss" scoped>
.media-viewer {
  z-index: 2;
  height: calc(100vh - 63px);
  .image, .audio {
    height: 100%;
    display: flex;
    background-color: #f9f9f9;
    .image-container {
      width: 100%;
      text-align: center;
      padding: 15px;
      overflow: auto;
      img {
        max-width: 100%;
        border-radius: 4px;
        object-fit: contain;
      }
    }
    .audio-container {
      flex: 1;
      text-align: center;
      padding: 15px;
      overflow: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .image-container,
    .audio-container {
      .extra-info {
        height: 45px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
      }
    }
    .vue-map-container {
      width: 40%;
      height: 100%;
      box-shadow: 0 3px 4px #a37979;
    }
  }
  .map {
    height: 100%;
    display: flex;
    flex-direction: column;
    .location-info {
      position: absolute;
      z-index: 1;
      top: 10px;
      right: 60px;
      padding: 10px 20px;
      background-color: #868686d0;
      color: #fff;
      font-size: 0.9rem;
      border-radius: 3px;
    }
    .vue-map-container {
      box-shadow: 0 5px 20px -2px #8a8a8a;
    }
  }
  .pdf {
    height: 100%;
  }
}
</style>
